module.exports = __webpack_public_path__ + "img/Weapon_94.c1407ff3.png";